import React, {useContext} from 'react';
import {
  selectLocalPeerID,
  selectPeers,
  useHMSStore,
} from '@100mslive/react-sdk';
import {Flex} from '@100mslive/roomkit-react';
import {AppContext} from '../context/AppContext';
import {GridCenterView, GridSidePaneView} from '../UI-Components/gridView';

export const MainGridView = () => {
  const {
    maxTileCount,
    showStatsOnTiles,
  } = useContext(AppContext);
  const peers: any = useHMSStore(selectPeers);
  const localPeerId = useHMSStore(selectLocalPeerID);
  const centerPeers = peers.filter(
    (peer: any) => peer.id !== localPeerId
  );
  const sidebarPeers = peers;

  /**
   * If there are peers from many publishing roles, then it's possible to divide
   * them into two parts, those who show in center and those who show in sidepane.
   * In case there is only one person in the room, then too sidepane will be shown
   * and center would be taken up by a banner image.
   * There is an issue currently, where the banner is still shown if there are
   * multiple viewers in the room but no publisher. Depending on the use case
   * this can be useful(for webinar) or look odd(for showing you're the only one).
   * Note that both center peers and sidebar peers have only publishing peers in them.
   */
  let showSidePane = centerPeers.length > 0 && sidebarPeers.length > 0;
  if (centerPeers.length === 0) {
    const itsOnlyMeInTheRoom =
      peers.length === 1 && peers[0].id === localPeerId;
    showSidePane = !itsOnlyMeInTheRoom;
  }
  return (
    <Flex
      css={{
        size: '100%',
        overflow: 'scroll',
      }}
      direction={{
        '@initial': 'row', // handle mobile grid views
        '@md': 'row',
      }}>
      <GridCenterView
        peers={showSidePane ? centerPeers : peers}
        maxTileCount={maxTileCount}
        // allowRemoteMute={false}
        hideSidePane={!showSidePane}
        totalPeers={peers.length}
        showStatsOnTiles={showStatsOnTiles}
      />
      {showSidePane && (
        <GridSidePaneView
          peers={sidebarPeers}
          maxTileCount={maxTileCount}
          // allowRemoteMute={false}
          hideSidePane={!showSidePane}
          totalPeers={peers.length}
          showStatsOnTiles={showStatsOnTiles}
        />
      )}
    </Flex>
  );
};
